<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Remove Coupon
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div>
                <p>Are you sure you want to remove this coupon?</p>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" :loading="loading" color="red">
                        Remove
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import type { Coupon } from '~/types/coupon'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
    coupon?: Coupon
}>()

const client = useSupabaseClient()
const toast = useToast()
const loading = ref<boolean>(false)

async function confirm() {
    if (props.coupon) {
        loading.value = true

        const { error } = await client.from('coupons')
            .update({ deleted_at: new Date() } as never)
            .eq('id', props.coupon.id)

        if (error) {
            toast.add({
                title: 'Could not delete coupon, please try again later.',
                color: 'red',
                icon: 'i-ph-warning-duotone'
            })
        }

        dismiss(true)
        loading.value = false
    }
}

function dismiss(reload: boolean = false) {
    emit('update:open', false)

    if (reload) {
        emit('reload', true)
    }
}
</script>